const INSPECTOR_COOKIE_KEY = 'inspector';
const INSPECTOR_COOKIE_ON_VALUE = 'on';

export {
  INSPECTOR_COOKIE_KEY,
  INSPECTOR_COOKIE_ON_VALUE
};
